/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { EnumPlaceholderKinds } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PlaceholdersController.
 */
export class PlaceholdersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /placeholders/{placeholdersKind}
     */
    public getPlaceholders(placeholdersKind: EnumPlaceholderKinds): Promise<Result<string[]>> {
        return this.http.get<Result<string[]>>(`/placeholders/${placeholdersKind}`);
    }
}
